<template>
  <div class="customer-batch-form">
    <fancy-input
      v-model="model.rangeStart"
      type="number"
      :label="$t('customer.number.start')"
      :min="0"
      :step="1"
    />
    <fancy-input
      v-model="model.amount"
      type="number"
      :label="$t('general.field.amount')"
      :min="0"
      :step="1"
    />
    <price-form v-model="model.balance" :label="$t('customer.balance.label')" />
    <simple-dropdown v-model="model.identifiers" :options="identifierOptions" :label="$t('customerIdentifier.label')" />
  </div>
</template>

<script>
import { computed, ref, watch } from 'vue';
import { cloneDeep } from 'lodash';
import { useI18n } from 'vue-i18n';
import FancyInput from '@/components/utils/forms/FancyInput.vue';
import PriceForm from '@/components/shared/forms/PriceForm.vue';
import SimpleDropdown from '@/components/utils/forms/SimpleDropdown.vue';
import { CUSTOMER_IDENTIFIER_TYPES } from '@/constants';

export default {
  name: 'CustomerBatchForm',
  components: {
    SimpleDropdown,
    FancyInput,
    PriceForm,
  },
  props: {
    modelValue: { type: Object, default: () => ({}) },
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const { t } = useI18n();
    const model = computed(() => props.modelValue);

    watch(() => cloneDeep(model), (value) => {
      emit('update:modelValue', value);
    });

    const identifierOptions = ref(Object.values(CUSTOMER_IDENTIFIER_TYPES).map((val) => (
      { key: val.toString(), label: t(`customerIdentifier.type.${val}`), value: [val] }
    )));

    return {
      model,
      identifierOptions,
    };
  },
};
</script>

<style lang="scss" scoped>
.customer-batch-form > *:not(:first-child) {
  @apply mt-4;
}
</style>
